<h2 mat-dialog-title>{{ data?.id ? ("module_edit" | transloco) : ("module_create" | transloco) }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab [label]="'base_data' | transloco">
            <mat-dialog-content
                [formGroup]="form"
                class="grid"
            >
                <mat-form-field class="full-width">
                    <mat-label>{{ "supertitle" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="preTitle"
                    />
                </mat-form-field>


                <mat-form-field class="full-width">
                    <mat-label>{{ "title" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="title"
                    />
                </mat-form-field>

                @if (hasPixlEditorDescription()) {
                    <div class="full-width border-area">
                        <mat-label>{{ "description" | transloco }}</mat-label>
                        <pixl-editor
                            [htmlString]="form.get('description')?.value || ''"
                            [editorHeight]="'auto'"
                            [bearerToken]="authToken!"
                            [assetUrl]="assetsUrl"
                            [mediaUrl]="mediaUrl"
                            [(editedHtmlString)]="descriptionHtml"
                        ></pixl-editor>
                    </div>
                } @else {
                    <mat-form-field class="full-width">
                        <mat-label>{{ "description" | transloco }}</mat-label>
                        <input
                            matInput
                            type="text"
                            required
                            placeholder=""
                            formControlName="description"
                        />
                    </mat-form-field>
                }

                <mat-form-field>
                    <mat-label>{{ "application" | transloco }}</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                        <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="preview-container border-area full-width">
                    <div class="content">
                        <div>
                            <button
                                class="extend-button"
                                mat-stroked-button
                                (click)="openImageChoice()"
                            >
                                <mat-icon>add_photo_alternate</mat-icon>
                                {{ "select_preview_image" | transloco }}
                            </button>
                        </div>

                        @if (getImageName() && getImageName().length > 0) {
                        <div>
                            <div class="media-container">
                                <div class="media-item">
                                    <div class="media-item">
                                        <img
                                            src="{{ imageUrl() }}"
                                            alt=""
                                            class="preview"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-1">
                            <span class="info cut-long-text">{{ getImageName() }}</span>
                        </div>

                        <div>
                            <button
                                mat-icon-button
                                (click)="deleteMediaEntry()"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>

                @if (isZavAdmin) {
                <div class="content-array-wrapper border-area full-width">
                    <div
                        formArrayName="content"
                        class="content-array-container"
                    >
                        @for (ctrl of contentControls.controls; track $index) {
                        <div class="content-item-row">
                            <mat-form-field class="content-input">
                                <input
                                    matInput
                                    placeholder="Content"
                                    [formControlName]="contentControls.controls.indexOf(ctrl)"
                                />
                            </mat-form-field>

                            <button
                                mat-icon-button
                                color="warn"
                                type="button"
                                class="remove-button"
                                (click)="removeContent(contentControls.controls.indexOf(ctrl))"
                                aria-label="Remove content item"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        }
                    </div>

                    <div class="add-button-wrapper">
                        <button
                            mat-raised-button
                            color="primary"
                            type="button"
                            (click)="addContent()"
                        >
                            <mat-icon>add</mat-icon>
                            {{ "add_content" | transloco }}
                        </button>
                    </div>
                </div>
                }

                <div class="filter-item">
                    <pixl-state-cb
                        [required]="true"
                        [initValue]="form.get('status')?.value"
                        (onStateChange)="statusChanged($event)"
                    />
                </div>

                <mat-form-field>
                    <mat-label>{{ "subjects_professions" | transloco }}</mat-label>
                    <mat-select
                        formControlName="subjects"
                        multiple
                    >
                        @for (subject of subjects$ | async; track subject.id) {
                        <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "school_classes" | transloco }}</mat-label>
                    <mat-select
                        formControlName="schoolClasses"
                        multiple
                    >
                        @for (schoolClass of schoolClasses$ | async; track schoolClass.id) {
                        <mat-option [value]="schoolClass.id">{{ "grade" | transloco }} {{ schoolClass.grade
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="border-area full-width">
                    <pixl-relation-table-select
                            [dialogWidth]="'1400px'"
                            [label]="'learning_units'"
                            [dialogTitle]="'learning_units'"
                            [searchLabel]="'search_by_id_or_title'"
                            [columns]="learningUnitColumns"
                            [displayColumn]="'title'"
                            [loadFn]="loadLearningUnitsFn"
                            [reorderable]="true"
                            [(selectedItems)]="selectedLearningUnits"
                            (selectionChange)="onLearningUnitsChanged($event)"
                    >
                    </pixl-relation-table-select>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || ('metadata' | transloco)">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata
                    [parentForm]="form"
                    [objectType]="'module'"
                ></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button
            mat-button
            (click)="cancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >{{ "save" | transloco }}</button>
    </mat-dialog-actions>
</div>